// import React from 'react';
// import ProdApk24 from '../prod-2.4.3.apk';
// import ProdApk23 from '../prod-2.3.1.apk';
import { Button, Typography } from 'antd';
import logo from "../assets/images/kravemart-logo-black.png";

const { Text } = Typography;

const DownloadRockyApp = () => {
  return (
    <div className='download-page'>
      <img src={logo} alt="logo" width="200px" />
      {/* <a
        href={ProdApk24}
        download="prod-2.4.3.apk"
        target="_blank"
      >
        <Button>Download Rocky New App</Button>
      </a> */}
      {/* <a
        href={ProdApk23}
        download="prod-2.3.1.apk"
        target="_blank"
      >
        <Text>Download Rocky Old App</Text>
      </a> */}
    </div>
  );
};

export default DownloadRockyApp;